<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C11.3096 6 10.75 6.55964 10.75 7.25V12.75C10.75 13.4404 11.3096 14 12 14C12.6904 14 13.25 13.4404 13.25 12.75V7.25C13.25 6.55964 12.6904 6 12 6ZM12 15C11.3096 15 10.75 15.5596 10.75 16.25C10.75 16.9403 11.3096 17.5 12 17.5C12.6904 17.5 13.25 16.9403 13.25 16.25C13.25 15.5596 12.6904 15 12 15Z" fill="currentColor"/>
	</svg>
</template>

<script>
  export default {};
</script>
